import React from 'react';
import { Box } from '@mui/material';

// Keyframes for the animation
const pulseAnimation = {
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(0.5)',
      opacity: 0.8,
    },
    '100%': {
      transform: 'scale(1.5)',
      opacity: 0,
    },
  },
};

const DangerIndicator = ({ size = 'medium' }) => {
  // Size mapping
  const sizeMap = {
    small: 8,
    medium: 10,
    large: 16,
  };

  const dotSize = sizeMap[size] || sizeMap.medium;

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: dotSize,
        height: dotSize,
      }}
    >
      {/* Animated outer circle */}
      <Box
        sx={{
          ...pulseAnimation,
          position: 'absolute',
          width: '100%',
          height: '100%',
          borderRadius: '50%',
          backgroundColor: '#dc2626',
          animation: 'pulse 1s ease-in-out infinite',
        }}
      />
      
      {/* Static inner circle - explicit red for critique alert */}
      <Box
        sx={{
          position: 'relative',
          width: '60%',
          height: '60%',
          borderRadius: '50%',
          backgroundColor: '#dc2626',
          zIndex: 1,
        }}
      />
    </Box>
  );
};


export default DangerIndicator;

// Usage examples:
// <DangerIndicator /> // Default medium size
// <DangerIndicator size="small" />
// <DangerIndicator size="large" />